module.exports = __webpack_public_path__ + "img/BAU Seniors_7.93232217.jpg";